import * as React from 'react';

export interface Props {
  className?: any;
  innerClassName?: any;
  background?: 'light' | 'none';
  children?: any;
}

const innerClasses = (props: Props) => `
  aspect-ratio
  aspect-ratio--1x1
  bg-ui-white-0
  ${props.innerClassName}`;

const wrapperClasses = (props: Props) => {
  return `bg-ui-white-0 ${props.className}`;
};

export const Panel = (props: Props) => (
  <div className={wrapperClasses(props)}>
    <div className={innerClasses(props)}>
      <div className="aspect-ratio--object cover z-1" />
      {props.children}
    </div>
  </div>
);

export default Panel;
